import React from 'react';

import "./style.scss";

const Logo = () => {
  return (
    <div className="logo">
      <h5>
        <div className="ligne">
          <span>Léanne Lopez</span>
        </div>
        <div className="ligne">
          <span>Designer graphique</span>
        </div>
      </h5>
    </div>
  );
};

export default Logo;